export const AddressSuggestionsComponent = {
    template: `
    <oo-alert ng-if="$ctrl.error.errorMessage" severity="error">
                <oo-alert-message>
                    <ng-form name="$ctrl.addressErrs"></ng-form>
                    {{$ctrl.error.errorMessage}}
                </oo-alert-message>

                <oo-alert-body class="field-group" ng-if="$ctrl.error.suggestedAddresses.length">
                    <p c-type="body-sm-primary bold">Suggested Addresses</p>
                        <select name="suggested-addresses" id="suggested-addresses"
                            class="field-control"
                            ng-change="$ctrl.setSuggestedAddress()"
                            ng-options="option.description for option in $ctrl.error.suggestedAddresses"
                            ng-model="$ctrl.selectedOption">
                            <option class="hidden-dropdown" value="">Select an Address</option>
                        </select>
                </oo-alert-body>
        </oo-alert>
    `,
    bindings: {
        error: '<',
        currentAddress: '<',
        onAddressSelection: '&'
    },
    controller: class {
        constructor(AddressUtilitiesService, googleAnalyticsTrackingService, $scope) {
            'ngInject';
            this.AddressUtilitiesService = AddressUtilitiesService;
            this.googleAnalyticsTrackingService = googleAnalyticsTrackingService;
            this.$scope = $scope;
        }

        $postLink() {
            this.$scope.$watch(
                () => this.error.errorMessage,
                errorMessage => this.addressErrs.$setValidity('invalid-address', !errorMessage)
            );
        }

        setSuggestedAddress() {
            this.googleAnalyticsTrackingService.trackSelectAddressSuggestion();
            let address = angular.merge(this.currentAddress, this.selectedOption);
            this.onAddressSelection({ address });
        }
    }
};
